import React from 'react';
import PropTypes from 'prop-types';
import strings from 'localization/strings';

import Button from '@material-ui/core/Button';
import { FieldArray } from 'react-final-form-arrays';
import MarginBox from 'common/MarginBox';
import StorageSiteLockSystemUserEditor from './StorageSiteLockSystemUserEditor';
import Typography from '@material-ui/core/Typography';

const StorageSiteLockSystemUsersEditor = ({ fieldNamePrefix }) => {
    const handleAdd = fields => {
        fields.push({
            id: null,
            name: null,
            description: null,
            lockSystemUserIdentifier: null,
            startDate: null,
            endDate: null
        });
    };

    const handleRemove = (fields, index) => {
        fields.remove(index);
    };

    return (
        <FieldArray name={fieldNamePrefix}>
            {({ fields }) => (
                <>
                    <Typography variant="h5" gutterBottom>
                        {strings.lockSystemUsers}
                    </Typography>
                    {
                        fields.length === 0 &&
                        (
                            <Typography variant="body1" gutterBottom>
                                {strings.noLockSystemUsers}
                            </Typography>
                        )
                    }
                    {
                        fields.map((name, index) => (
                            <StorageSiteLockSystemUserEditor
                                key={index}
                                fieldNamePrefix={name}
                                onRemove={() => handleRemove(fields, index)}
                            />
                        ))
                    }
                    <MarginBox bottom={2}>
                        <Button
                            size="small"
                            color="primary"
                            variant="outlined"
                            onClick={() => handleAdd(fields)}
                        >
                            {strings.addUser}
                        </Button>
                    </MarginBox>
                </>
            )}
        </FieldArray>
    );
};

StorageSiteLockSystemUsersEditor.propTypes = {
    fieldNamePrefix: PropTypes.string.isRequired
};

export default StorageSiteLockSystemUsersEditor;
